/* unplugin-vue-components disabled */const { ref, computed, onMounted, provide } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-ecc2a80a"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "main" };
const _hoisted_2 = { class: "center" };
const _hoisted_3 = { class: "content" };
const work_1 = require("@/store/modules/work");
const Project_vue_1 = tslib_1.__importDefault(require("@/layout/Project.vue"));
const LeftBar_vue_1 = tslib_1.__importDefault(require("@/layout/LeftBar.vue"));
const TopBar_vue_1 = tslib_1.__importDefault(require("@/layout/TopBar.vue"));
const index_vue_1 = tslib_1.__importDefault(require("@/views/laborer/index.vue"));
const model_1 = require("@/model");
const one_message_1 = require("@/utils/one_message");
const index_vue_2 = tslib_1.__importDefault(require("@/components/AddProjectDialog/index.vue"));
const index_vue_3 = tslib_1.__importDefault(require("@/components/ProjectConflictDialog/index.vue"));
const project_1 = require("@/service/project");
const router_1 = tslib_1.__importDefault(require("@/router"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'Main',
    setup(__props) {
        const store = (0, work_1.useWork)();
        const projectsRef = ref(Project_vue_1.default);
        const laborerPage = ref(index_vue_1.default);
        const curPage = computed(() => router_1.default.currentRoute.value.name);
        const projectConflictRef = ref();
        function openProjectView() {
            projectsRef.value.show();
        }
        function delProject() {
            projectsRef.value.refreshProjects();
        }
        function copyProject(id) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield handleAddProject(id);
            });
        }
        function onLeftBarSelect(val) {
            var _a;
            if (val == "program" || val === "laborer") {
                let robots = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.findMachineByType(model_1.ENTITY_TYPE.ROBOT);
                if (!(robots === null || robots === void 0 ? void 0 : robots.length)) {
                    (0, one_message_1.oneMessage)({
                        message: "请先添加机器人",
                        grouping: true,
                        type: 'warning'
                    });
                    val = 'design';
                }
            }
            router_1.default.push({ name: val });
        }
        function onCfgClick(data) {
            laborerPage.value && laborerPage.value.openCfg(data.id);
        }
        const addProjectDialog = ref();
        function handleAddProject(id) {
            var _a;
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                try {
                    yield addProjectDialog.value.handleNewProject(id);
                    (_a = projectsRef.value) === null || _a === void 0 ? void 0 : _a.close();
                }
                catch (e) {
                    console.log(e);
                }
            });
        }
        onMounted(() => {
            project_1.ProjectService.current().initProjectConflictDialog(projectConflictRef.value.openProjectConflictDialog);
        });
        provide('onLeftBarSelect', onLeftBarSelect);
        return (_ctx, _cache) => {
            const _component_router_view = (0, vue_2.resolveComponent)("router-view");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(Project_vue_1.default, {
                    ref_key: "projectsRef",
                    ref: projectsRef,
                    onCfgClick: onCfgClick,
                    onAddProject: _cache[0] || (_cache[0] = ($event) => (handleAddProject())),
                    onCopyProject: copyProject
                }, null, 512),
                (0, vue_2.createVNode)(index_vue_2.default, {
                    ref_key: "addProjectDialog",
                    ref: addProjectDialog,
                    onOpenProject: openProjectView
                }, null, 512),
                (0, vue_2.createVNode)(index_vue_3.default, {
                    ref_key: "projectConflictRef",
                    ref: projectConflictRef
                }, null, 512),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.withDirectives)((0, vue_2.createVNode)(LeftBar_vue_1.default, {
                        onOpenProject: openProjectView,
                        onHandleSelect: onLeftBarSelect,
                        class: "left-bar"
                    }, null, 512), [
                        [vue_2.vShow, (0, vue_2.unref)(curPage) !== 'laborer']
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createVNode)(TopBar_vue_1.default, {
                            onCopyProject: copyProject,
                            onOpenProject: openProjectView,
                            onDelProject: delProject,
                            class: "top-bar"
                        }),
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createVNode)(_component_router_view, {
                                onOpenProject: openProjectView,
                                onOnProgramNodeClick: _cache[1] || (_cache[1] = ($event) => (onLeftBarSelect('program')))
                            }, {
                                default: (0, vue_2.withCtx)(({ Component }) => [
                                    ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.KeepAlive, { include: "design" }, [
                                        ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)(Component)))
                                    ], 1024))
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
